import React, { useState } from "react";
import { Paragraph } from "@project-stories/elements/Paragraph/Paragraph";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { useKlaviyoSubscribe } from "@arctheme-hooks/useKlaviyoSubscribe";
import {SocialIcons} from "../FooterSocial/SocialIcons";
import SubscribeForm from "./SubscribeForm";
import SubscribeMessage from "./SubscribeMessage";

export const FooterSubscribe = ({ id, shop, globals, settings, list_links }) => {
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

    const { isLoading, error, success, subscribe } = useKlaviyoSubscribe(
        `${globals.klaviyo_api_url}/client/subscriptions?company_id=${globals.klaviyo_public_api_key}`,
        globals.klaviyo_subscriber_list_id,
    );

    const [email, setEmail] = useState("");

    return (
        <div key={id} className={`footers-link-list max-lg:mb-5`}>
            <SocialIcons shop={shop} list_links={list_links} />
            <div className={`${isMobile ? "block h5" : "hidden lg:block h4"} mt-[24px] lg:mt-[32px] pr-2`}>
                {list_links.settings.title}
            </div>
            <Paragraph text={list_links.settings.contact_info} type="b3" />
            <Paragraph text={list_links.settings.content} type={`${isMobile ? "b3" : "b2"} mt-[8px]`} />
            <SubscribeForm email={email} setEmail={setEmail} subscribe={subscribe} isMobile={isMobile} />
            <SubscribeMessage error={error} success={success} />
            <div className="sign-up-message">
                <Paragraph text={list_links.settings.sign_up_message} type={`${isMobile ? "brs" : "b4"}`} />
            </div>
        </div>
    );
};
